import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {DateTime} from 'luxon';
import {Circular} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiComService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** comunicaciones ***/

  getNotas(aula: number): Promise<Circular[]> {
    const url = `${this.apiUrl}comunicaciones/${aula}`;
    return firstValueFrom(this.http.get<Circular[]>(url))
  }
  getNota(aula: number): Promise<Circular> {
    const today = DateTime.now().toSQLDate();
    const url = `${this.apiUrl}comunicaciones/${aula}/nota/${today}`;
    return firstValueFrom(this.http.get<Circular>(url))
  }
  getCircular(aula: number, fecha: string): Promise<Circular> {
    const url = `${this.apiUrl}comunicaciones/${aula}/circular/${fecha}`;
    return firstValueFrom(this.http.get<Circular>(url))
  }
  getHistoricoComunicaciones(aula: number, tipo: string, from?: string, to?: string): Promise<Circular[]> {
    let url = `${this.apiUrl}comunicaciones/historico/${aula}/${tipo}/${from}/${to}`;
    if (!from) url = `${this.apiUrl}comunicaciones/historico/${aula}/${tipo}`;
    return firstValueFrom(this.http.get<Circular[]>(url))
  }
  getFechasNotas(): Promise<Circular[]> {
    const url = `${this.apiUrl}comunicaciones/fotos/fechas`;
    return firstValueFrom(this.http.get<Circular[]>(url))
  }
  getNotasCurso(curso: string): Promise<Circular[]> {
    const url = `${this.apiUrl}comunicaciones/fotos/${curso}`;
    return firstValueFrom(this.http.get<Circular[]>(url))
  }
  // updateNota(datos: Circular): Promise<any> {
  //   const url = `${this.apiUrl}comunicaciones`;
  //   return firstValueFrom(this.http.post<any>(url, datos))
  // }
  // updateCircular(datos: {tipo: 'CIRCULAR', aula: number, imagen: string,
  //   file: string, texto: string, fecha: string}): Promise<void> {
  //   const url = `${this.apiUrl}comunicaciones`;
  //   return firstValueFrom(this.http.post<void>(url, datos))
  // }
  update(datos: Circular): Promise<any> {
    const url = `${this.apiUrl}comunicaciones`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  borrarCircular(aula: number, tipo: string, fecha: string): Promise<any> {
    const url = `${this.apiUrl}comunicaciones/${aula}/${tipo}/${fecha}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
